import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';

export interface PageNavigationProps {
  idx: number;
  total: number;
}

export function PageNavigation({idx, total}: PageNavigationProps) {
  return (
    <div className="inline-flex h-20pxr px-4pxr justify-center items-center shrink-0 rounded-[100px] bg-[rgb(var(--colors-static-mono-black)_/_40%)]">
      <Text className="text-static-mono-white text-center font-x-small2-bold w-14pxr">
        {idx}
      </Text>
      <Icon type={IconType.ListBannerSlashStatic} />
      <Text className="text-static-mono-white text-center font-x-small2-bold w-14pxr opacity-50">
        {total}
      </Text>
    </div>
  );
}
